import React, { Component } from 'react';
import { connect } from 'react-redux';
import {GridList,GridListTile,GridListTileBar} from '@material-ui/core'
import './ArticleList.css'

var $commonWords = ['use','js','me','you','learn','best','can','great','some','text','i','a','about','an','and','are','as','at','be','by','com','de','en','for','from','how','in','is','it','la','of','on','or','that','the','this','to','was','what','when','where','who','will','with','und','the','www','we'];

class ArticleList extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
      let $text=this.props.state.links.links.searchString;
        $text = $text.replace(/[^\w\d ]/g, '');
 
        var result = $text.split(' ');
      
      // remove $commonWords
      result = result.filter(function (word) {
          return $commonWords.indexOf(word) === -1;
      });

      result = result.filter(function(elem, pos) {
          return result.indexOf(elem) == pos;
        });
      let stringComp="https://loremflickr.com/700/400/";
      if(result){
        if(result.length>2){
          stringComp=stringComp+result[0]+","+result[1];
        }
        else{
          stringComp=stringComp+result[0];
        }
      }
      
        return ( 
            <div className="articleBase">
                 {
                    (this.props.state)?<GridList className="articleGrid" cols={2.5} style={{flexWrap: 'nowrap',
                    transform: 'translateZ(0)'}}>
                    {this.props.state.links.links.articlesEnd.map((ele)=>{
                      let randNum=Math.floor(Math.random() * 10000);
                      stringComp=stringComp+"?random="+randNum.toString();
                      return <GridListTile key={ele.link}>
                     <a href={ele.link}><img src={stringComp} /></a> 
            <GridListTileBar title={ele.link}></GridListTileBar>
          </GridListTile>
                    })}
                    </GridList>:<div>Not updated Yet</div>
                  }
            </div>
         );
    }
}
 
const mapStateToProps = (state) => {
    console.log('i am called when store is updated',state)
    return {
      state: state
    };
  }
  
  const mapDispatchToProps=(dispatch)=>{
  return ({
    addLinksToStore:(payload)=>{dispatch({type:'ADD_LINKS',payload:payload})}
  })
  }
   
  export default connect(mapStateToProps,mapDispatchToProps)(ArticleList);


// WEBPACK FOOTER //
// ./src/components/ArticleList.js